import { NavigationMenu } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import type { ReactElement, ReactNode, MouseEventHandler } from "react";
import type {
  SiteNavigationGroup,
  SiteNavigationLink,
  SiteNavigationLinkProps,
} from "./site-navigation-types";
import { SiteNavigationAction } from "./site-navigation-action";
import { SiteNavigationDoor } from "./site-navigation-door";

export function SiteNavigationDesktop({
  doors,
  menus,
  label,
  account,
  action,
  renderLink,
  onNavigate: closeOnNavigation,
}: {
  readonly doors: readonly SiteNavigationLink[];
  readonly menus: readonly SiteNavigationGroup[];
  readonly label: string | undefined;
  readonly account: ReactNode;
  readonly action: SiteNavigationLink | null;
  readonly renderLink: (props: SiteNavigationLinkProps) => ReactElement;
  readonly onNavigate: MouseEventHandler<HTMLAnchorElement>;
}) {
  return (
    <div {...stylex.props(styles.desktop)}>
      {doors.length > 0 && (
        <nav aria-label={label} {...stylex.props(styles.desktopDoors)}>
          {doors.map((door) => (
            <span key={door.href}>
              {
                <SiteNavigationDoor
                  item={door}
                  mobile={false}
                  renderLink={renderLink}
                  onNavigate={closeOnNavigation}
                />
              }
            </span>
          ))}
        </nav>
      )}
      {menus.length > 0 && (
        <NavigationMenu
          items={menus}
          renderLink={(item) => renderLink({ href: item.href })}
          ariaLabel={label ?? "Main navigation"}
        />
      )}
      {account ?? (
        <SiteNavigationAction action={action} renderLink={renderLink} />
      )}
    </div>
  );
}

const styles = stylex.create({
  desktop: {
    display: { default: "none", "@media (min-width: 900px)": "flex" },
    alignItems: "center",
    gap: 20,
  },
  desktopDoors: { display: "flex", alignItems: "center", gap: 20 },
});
